export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9691.2d17dd0e.jpg";